import { IonTabBar, IonTabButton, IonIcon, IonLabel } from '@ionic/react';
import {waterOutline, settingsOutline, gridOutline, bagOutline} from 'ionicons/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import './BottomNav.css';

export const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path: string) => location.pathname === path;

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <IonTabBar className="bottom-nav">
      <IonTabButton
        onClick={() => handleNavigation('/dashboard')}
        className={isActive('/dashboard') ? 'tab-active' : ''}
      >
        <IonIcon
          icon={gridOutline }
          className={isActive('/dashboard') ? 'icon-active' : 'icon-inactive'}
        />
        <IonLabel className={isActive('/dashboard') ? 'label-active' : 'label-inactive'}>
          Tableau bord
        </IonLabel>
      </IonTabButton>

      <IonTabButton
        onClick={() => handleNavigation('/production')}
        className={isActive('/production') ? 'tab-active' : ''}
      >
        <IonIcon
          icon={waterOutline}
          className={isActive('/production') ? 'icon-active' : 'icon-inactive'}
        />
        <IonLabel className={isActive('/production') ? 'label-active' : 'label-inactive'}>
          Production
        </IonLabel>
      </IonTabButton>

        <IonTabButton
            onClick={() => handleNavigation('/products')}
            className={isActive('/products') ? 'tab-active' : ''}
        >
            <IonIcon
                icon={bagOutline}
                className={isActive('/products') ? 'icon-active' : 'icon-inactive'}
            />
            <IonLabel className={isActive('/products') ? 'label-active' : 'label-inactive'}>
                Transformation
            </IonLabel>
        </IonTabButton>

      <IonTabButton
        onClick={() => handleNavigation('/settings')}
        className={isActive('/settings') ? 'tab-active' : ''}
      >
        <IonIcon
          icon={settingsOutline}
          className={isActive('/settings') ? 'icon-active' : 'icon-inactive'}
        />
        <IonLabel className={isActive('/settings') ? 'label-active' : 'label-inactive'}>
          Réglages
        </IonLabel>
      </IonTabButton>
    </IonTabBar>
  );
};
